import React from 'react';
import {
  Button,
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Http from "../Http"
import Select2 from 'react-select2-wrapper';

class Superadmin extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      userId: null,
    }

    this.api = '/api/v1';
    //QCLIENT: env aggiungere api link
    this.onUserIdChange = this.onUserIdChange.bind(this)
    this.setUserFromSuperadmin = this.setUserFromSuperadmin.bind(this)
  }

  componentDidMount() {
    Http.get(`${this.api}/users`)
      .then((response) => {
        this.setState({ users: response.data.data.users })
      })
  }

  setUserFromSuperadmin() {
    let { userId } = this.state
    const data = new FormData()
    data.append('userId', userId)
    Http.post(`/oauth/set-user`, data, {}
    ).then(res => {
      //cambio l'utente
      localStorage.setItem("user", JSON.stringify(res.data.data.user));
      localStorage.setItem("access_token", res.data.data.access_token);
      Http.defaults.headers.common.Authorization = "Bearer " + res.data.data.access_token;
      window.location.reload(false);
    }).catch((e) => {
      console.log(e)
      alert("Si è verificato un errore")
    });
  }

  getUsersOptions() {
    const { users } = this.state;
    return users.map((user, index) => {
      if (user.companies.length > 0) {
        return {
          text: user.companies[0].name.toUpperCase() + " - " + user.email,
          id: user.id,
          key: user.id
        };
      }

    });
  }

  onUserIdChange(event) {
    this.setState({ userId: event.target.value });
  }

  render() {
    return (
      <div className="content">
        <div className="wrapper">
          <div className="main-panel">
            <Row className='mx-0'>
              <Col md="12">
                <Card>
                  <Row>
                    <Col md="12" className="mb-3">
                      <h3 className="text-left p-3">SCEGLI UNA AZIENDA</h3>
                    </Col>
                  </Row>
                  <CardBody>
                    <p className="text-left">L'utente attuale è di tipo superadmin. Scegli un'azienda per visualizzare Qcompetitor con i dati dell'azienda scelta.</p>
                    <Row>
                      <Col md="6" className="mb-3">
                        <label className="" for="userId">Utente</label>
                        <Select2
                          name="userId"
                          id="userId"
                          value={this.state.userId}
                          data={this.getUsersOptions()}
                          onChange={this.onUserIdChange}
                          options={
                            {
                              placeholder: 'Seleziona un utente',
                              width: '100%'
                            }
                          }
                        />
                      </Col>
                      <Col md="6">
                        <Button className="animation-on-hover float-right btn btn-primary my-3" onClick={this.setUserFromSuperadmin}>Continua</Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>)
  }
}

Superadmin.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Superadmin);